function truncateParagraph2() {
    const text = document.querySelector(".hero-home-2025-section .hero-paragraph.truncated");
    const readMoreBtn = document.querySelector("#read-more-button-new");

    const fullHeight = text?.offsetHeight ?? 0;

    const mediaQueryList = window.matchMedia("(max-width: 767px)");

    function checkResolution(e) {
        if (e.matches) {
            // Si la resolución es menor o igual a 768px
            if (fullHeight > 2 * parseFloat(getComputedStyle(text).lineHeight ?? '1')) {
                readMoreBtn.style.display = "flex";
            } else {
                readMoreBtn.style.display = "none";
            }
        } else {
            // Si la resolución es mayor a 768px
            readMoreBtn.style.display = "none";
        }
    }

    // Comprueba la resolución inicial
    checkResolution(mediaQueryList);
    // Añade el listener para cambios de resolución
    mediaQueryList.addListener(checkResolution);

    readMoreBtn.addEventListener("click", function () {
        if (text) {
            if (text.classList.contains("truncated")) {
                text.classList.remove("truncated");
                readMoreBtn.innerText = "Read Less";
            } else {
                text.classList.add("truncated");
                readMoreBtn.innerText = "Read More";
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", truncateParagraph2);